




































































































import { UsePendingCollection } from "@/common/composition/pending-collection";
import { InformationType } from "@/common/models";
import { SharedState } from "@/common/state";
import { are_2_objects_equal_by } from "@/fp";
import { computed, onMounted, ref } from "@vue/composition-api";
import Vue from "vue";
import AppCheckbox from "../AppCheckbox.vue";
import PassivePopup from "../PassivePopup.vue";

type DDItem = { id: string; name: string; selected: boolean };
export default Vue.extend({
  components: { PassivePopup, AppCheckbox },
  props: ["label_id"],
  setup(props, { emit }) {
    const show_popup = ref(false);
    const {
      init,
      pending_items,
      commit_changes,
      discard_changes,
      has_pending_changes,
      update_item,
    } = UsePendingCollection<DDItem>({
      seed: [],
      check_change_by_prop: "selected",
      uniq_prop: "id",
    });

    const is_same_sensitivity_and_code =
      are_2_objects_equal_by<InformationType>("code", "sensitivity");

    onMounted(() => {
      const v_label_id = props.label_id as string;
      const v_label = SharedState.getInfoType(v_label_id);
      //  const filter_fn = is_same_sensitivity_and_code(v_label);
      const display_labels = Object.values(SharedState.allInfoTypes.value)
        .filter((l) => {
          return (
            (l.code === v_label.code || l.content_code === v_label.code) &&
            l.sensitivity == v_label.sensitivity
          );
        })
        .map((l) => {
          return {
            id: l.id,
            name: l.labelName,
            selected: true,
          };
        });
      console.log("display_labels:", display_labels);
      init(display_labels);
    });

    const selected_items = computed(() =>
      pending_items.value.filter((f) => f.selected)
    );

    const selected_labels_names = computed(() =>
      selected_items.value.map((f) => f.name).join(", ")
    );

    const on_change = (is_on: boolean, item: DDItem) => {
      if (
        selected_items.value.length === 1 &&
        selected_items.value[0].name === item.name
      ) {
        return;
      }
      update_item({
        ...item,
        selected: is_on,
      });
    };

    const apply = () => {
      commit_changes();
      emit(
        "on_change",
        pending_items.value.filter((f) => f.selected).map((f) => f.id)
      );
      close_popup();
    };
    const reset = () => {
      discard_changes();
      close_popup();
    };

    const close_popup = () => (show_popup.value = false);

    return {
      show_popup,
      selected_labels_names,
      items: pending_items,
      on_change,
      has_pending_changes,
      apply,
      reset,
    };
  },
});
